// apps/frontend/src/lib/signInEmail.ts

/**
 * The e-mail address as Firebase reports it (trimmed, lower-cased). Used for
 * what is stored as `emailForSignIn` and for every comparison with
 * `currentUser.email` on the e-mail-link callback. A capital typed on the
 * login form (or stored by it) used to turn the parallel-tab rescue into
 * "expired" and the same-account check into an extra sign-out (plan
 * 2026-10-28-partner-aware-invitation-flow, step 0 / D6).
 */
export function normalizeSignInEmail(email: string): string {
  return email.trim().toLowerCase();
}
